














































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import TopArticleCard from '~/components/pages/Top/TopArticleCard.vue';
import TopSection from '~/components/pages/Top/TopSection.vue';
import AppArticleCard from '~/components/partials/App/AppArticleCard.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import { url } from '~/utils';
import { ArticleCard, EditorProfile, ArticleCategory } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppArticleCard,
    AppImage,
    TopSection,
    TopArticleCard,
  },
  props: {
    featuredItem: {
      type: Object as PropType<ArticleCard>,
      default: undefined,
    },
    featuredAuthor: {
      type: Array as PropType<EditorProfile[]>,
      default: () => [],
    },
    items: {
      type: Array as PropType<ArticleCard[]>,
      required: true,
    },
    authors: {
      type: Array as PropType<EditorProfile[]>,
      default: () => [],
    },
    categories: {
      type: Array as PropType<ArticleCategory[]>,
      default: () => [],
    },
  },
  setup() {
    return { url };
  },
});
